import { Component } from '@angular/core';

@Component({
  selector: 'app-main-payment-requests',
  templateUrl: './main-payment-requests.component.html',
  styleUrls: ['./main-payment-requests.component.css'],
})
export class MainPaymentRequestsComponent {}
